$bog_gamengine_draw $mol_view
	dom_name \canvas
	field *
		^
		width <= width 0
		height <= height 0
	dpr 1
	scene $bog_gamengine_scene
	cam $bog_gamengine_cam
	light_dir Float32Array
	clear? Float32Array
	fog? Float32Array
	fog_color? Float32Array
	ambient 0.35
	wireframe? false
	shadows? true
	shadow_size? 2048
	shadow_range? 20
	post? true
	Tone $bog_gamengine_shader_post_tone
	passes /
		<= Tone
	stat \
	peak 0
	report *
		tick 0
		fill 0
		shadow 0
		main 0
		post 0
		batches 0
		instances 0
		draws 0
		triangles 0
		bytes 0
